import React from 'react';

export const ShutterLeftOpeningPostCenterOpeningPostRight = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 135.16 59.3"
      width="136"
      {...props}
    >
      <g data-name="Group 83-2">
        <g data-name="Group 483">
          <path
            data-name="Rectangle 166"
            fill="#fff"
            d="M5.49.59h124.17v50.8H5.49z"
          />
          <path
            data-name="Path 2322"
            d="M4.72 51.4V.59A.71.71 0 015.49 0h124.17c.43 0 .78.26.78.59V51.4c0 .32-.35.58-.78.58H5.49a.68.68 0 01-.77-.58zM128.89 1.18H6.26v49.63h122.63z"
            fill="#dcd9d5"
          />
        </g>
        <g data-name="Group 484">
          <path
            data-name="Rectangle 167"
            fill="#fff"
            d="M5.49.59h124.17v50.8H5.49z"
          />
          <path
            data-name="Path 2323"
            d="M4.72 51.4V.59A.71.71 0 015.49 0h124.17c.43 0 .78.26.78.59V51.4c0 .32-.35.58-.78.58H5.49a.68.68 0 01-.77-.58zM128.89 1.18H6.26v49.63h122.63z"
            fill="#dcd9d5"
          />
        </g>
        <g data-name="Group 485" fill="#dcd9d5">
          <path data-name="Rectangle 168" d="M9.9 3.94h116.78v44.1H9.9z" />
          <path
            data-name="Path 2324"
            d="M9.89 48.63c-.42 0-.77-.26-.76-.58V3.94c0-.32.34-.58.77-.58h116.77c.43 0-.65.26-.65.58V48c0 .32 1.08.58.65.58H9.89zm116-44.1H10.67v42.93H125.9z"
          />
        </g>
        <path
          data-name="Path 2325"
          d="M.73 52h133.7c.4 0 .73-.25.73-.55a.66.66 0 00-.73-.56H.73a.65.65 0 00-.73.51c0 .3.33.6.73.6z"
          fill="#dcd9d5"
        />
      </g>
      <g data-name="Group 85">
        <g data-name="Group 498">
          <path
            data-name="Rectangle 182"
            fill="#233762"
            d="M68.88 8.28l27.79-6.03v49.49l-27.79 6.8V8.28z"
          />
          <path
            data-name="Path 2338"
            d="M97.16 52.25l-28.78 7V7.75l28.78-6.23zm-27.78 5.54l26.8-6.55V3l-26.8 5.79z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499">
          <path
            data-name="Rectangle 183"
            fill="#233762"
            d="M71.88 12.94l22.04-4.85v3.56l-22.04 4.9v-3.61z"
          />
          <path
            data-name="Path 2339"
            d="M94.18 11.92l-22.55 5v-4.26l22.55-4.95zm-22 4.23l21.53-4.77V8.46L72.14 13.2z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500">
          <path
            data-name="Rectangle 184"
            fill="#233762"
            d="M71.88 16.55l22.04-4.9v3.57l-22.04 4.94v-3.61z"
          />
          <path
            data-name="Path 2340"
            d="M94.18 15.48l-22.55 5.06v-4.27l22.55-5zm-22 4.28L93.67 15v-3l-21.53 4.81z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501">
          <path
            data-name="Rectangle 185"
            fill="#233762"
            d="M71.88 20.16l22.04-4.94v3.58l-22.04 4.97v-3.61z"
          />
          <path
            data-name="Path 2341"
            d="M94.18 19.05l-22.55 5.11v-4.28l22.55-5zm-22 4.34l21.53-4.87V15.6l-21.57 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502">
          <path
            data-name="Rectangle 186"
            fill="#233762"
            d="M71.88 23.8l22.04-4.98v3.57l-22.04 5.02V23.8z"
          />
          <path
            data-name="Path 2342"
            d="M94.18 22.65L71.63 27.8v-4.27l22.55-5.1zM72.14 27l21.53-4.9v-2.91l-21.53 4.88z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503">
          <path
            data-name="Rectangle 187"
            fill="#233762"
            d="M71.88 27.41l22.04-5.02v3.57l-22.04 5.06v-3.61z"
          />
          <path
            data-name="Path 2343"
            d="M94.18 26.22l-22.55 5.19v-4.27L94.18 22zm-22 4.41l21.53-4.94v-2.92l-21.57 4.91z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504">
          <path
            data-name="Rectangle 188"
            fill="#233762"
            d="M71.88 31.02l22.04-5.06v3.56l-22.04 5.11v-3.61z"
          />
          <path
            data-name="Path 2344"
            d="M94.18 29.79L71.63 35v-4.25l22.55-5.18zm-22 4.46l21.53-5v-2.91l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505">
          <path
            data-name="Rectangle 189"
            fill="#233762"
            d="M71.88 34.63l22.04-5.11v3.57l-22.04 5.15v-3.61z"
          />
          <path
            data-name="Path 2345"
            d="M94.18 33.35l-22.55 5.28v-4.26l22.55-5.23zm-22 4.51l21.53-5v-3l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506">
          <path
            data-name="Rectangle 190"
            fill="#233762"
            d="M71.88 38.24l22.04-5.15v3.57l-22.04 5.2v-3.62z"
          />
          <path
            data-name="Path 2346"
            d="M94.18 36.92l-22.55 5.33V38l22.55-5.3zm-22 4.55l21.53-5.08v-2.92l-21.53 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507">
          <path
            data-name="Rectangle 191"
            fill="#233762"
            d="M71.88 41.86l22.04-5.2v3.56l-22.04 5.25v-3.61z"
          />
          <path
            data-name="Path 2347"
            d="M94.18 40.49l-22.55 5.37v-4.27l22.55-5.31zm-22 4.59L93.67 40v-3l-21.53 5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508">
          <path
            data-name="Rectangle 192"
            fill="#233762"
            d="M71.88 45.49l22.04-5.24v3.57l-22.04 5.29v-3.62z"
          />
          <path
            data-name="Path 2348"
            d="M94.18 44.08L71.63 49.5v-4.27l22.55-5.36zm-22 4.64l21.53-5.17v-2.92l-21.57 5.13z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509">
          <path
            data-name="Rectangle 193"
            fill="#233762"
            d="M71.88 49.11l22.04-5.29v3.57l-22.04 5.33v-3.61z"
          />
          <path
            data-name="Path 2349"
            d="M94.18 47.65l-22.55 5.46v-4.27l22.55-5.41zm-22 4.68l21.53-5.21V44.2l-21.57 5.17z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194"
          fill="#fff"
          d="M82.35 10.63l1.44-.32v39.53l-1.44.35V10.63z"
        />
      </g>
      <g data-name="Group 85-2">
        <g data-name="Group 498-2">
          <path
            data-name="Rectangle 182-2"
            fill="#233762"
            d="M100.61 8.28l27.8-6.03v49.49l-27.8 6.8V8.28z"
          />
          <path
            data-name="Path 2338-2"
            d="M128.89 52.25l-28.78 7V7.75l28.78-6.23zm-27.78 5.54l26.81-6.55V3l-26.81 5.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-2">
          <path
            data-name="Rectangle 183-2"
            fill="#233762"
            d="M103.61 12.94l22.05-4.85v3.56l-22.05 4.9v-3.61z"
          />
          <path
            data-name="Path 2339-2"
            d="M125.92 11.92l-22.57 5v-4.26l22.57-4.95zm-22 4.23l21.54-4.77V8.46l-21.59 4.74z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-2">
          <path
            data-name="Rectangle 184-2"
            fill="#233762"
            d="M103.61 16.55l22.05-4.9v3.57l-22.05 4.94v-3.61z"
          />
          <path
            data-name="Path 2340-2"
            d="M125.92 15.48l-22.57 5.06v-4.27l22.57-5zm-22 4.28L125.41 15v-3l-21.54 4.78z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-2">
          <path
            data-name="Rectangle 185-2"
            fill="#233762"
            d="M103.61 20.16l22.05-4.94v3.58l-22.05 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-2"
            d="M125.92 19.05l-22.57 5.11v-4.28l22.57-5zm-22 4.34l21.54-4.87V15.6l-21.54 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-2">
          <path
            data-name="Rectangle 186-2"
            fill="#233762"
            d="M103.61 23.8l22.05-4.98v3.57l-22.05 5.02V23.8z"
          />
          <path
            data-name="Path 2342-2"
            d="M125.92 22.65l-22.57 5.15v-4.27l22.57-5.1zm-22 4.37l21.54-4.9v-2.93l-21.54 4.88z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-2">
          <path
            data-name="Rectangle 187-2"
            fill="#233762"
            d="M103.61 27.41l22.05-5.02v3.57l-22.05 5.06v-3.61z"
          />
          <path
            data-name="Path 2343-2"
            d="M125.92 26.22l-22.57 5.19v-4.27L125.92 22zm-22 4.41l21.54-4.94v-2.92l-21.54 4.91z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-2">
          <path
            data-name="Rectangle 188-2"
            fill="#233762"
            d="M103.61 31.02l22.05-5.06v3.56l-22.05 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-2"
            d="M125.92 29.79L103.35 35v-4.25l22.57-5.18zm-22 4.46l21.54-5v-2.91l-21.54 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-2">
          <path
            data-name="Rectangle 189-2"
            fill="#233762"
            d="M103.61 34.63l22.05-5.11v3.57l-22.05 5.15v-3.61z"
          />
          <path
            data-name="Path 2345-2"
            d="M125.92 33.35l-22.57 5.28v-4.26l22.57-5.23zm-22 4.51l21.54-5v-3l-21.54 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-2">
          <path
            data-name="Rectangle 190-2"
            fill="#233762"
            d="M103.61 38.24l22.05-5.15v3.57l-22.05 5.2v-3.62z"
          />
          <path
            data-name="Path 2346-2"
            d="M125.92 36.92l-22.57 5.33V38l22.57-5.27zm-22 4.55l21.54-5.08v-2.92l-21.54 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-2">
          <path
            data-name="Rectangle 191-2"
            fill="#233762"
            d="M103.61 41.86l22.05-5.2v3.56l-22.05 5.25v-3.61z"
          />
          <path
            data-name="Path 2347-2"
            d="M125.92 40.49l-22.57 5.37v-4.27l22.57-5.31zm-22 4.59L125.41 40v-3l-21.54 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-2">
          <path
            data-name="Rectangle 192-2"
            fill="#233762"
            d="M103.61 45.49l22.05-5.24v3.57l-22.05 5.29v-3.62z"
          />
          <path
            data-name="Path 2348-2"
            d="M125.92 44.08l-22.57 5.42v-4.27l22.57-5.36zm-22 4.64l21.54-5.17v-2.92l-21.54 5.13z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-2">
          <path
            data-name="Rectangle 193-2"
            fill="#233762"
            d="M103.61 49.11l22.05-5.29v3.57l-22.05 5.33v-3.61z"
          />
          <path
            data-name="Path 2349-2"
            d="M125.92 47.65l-22.57 5.46v-4.27l22.57-5.41zm-22 4.68l21.54-5.21V44.2l-21.54 5.17z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-2"
          fill="#fff"
          d="M114.08 10.63l1.45-.32v39.53l-1.45.35V10.63z"
        />
      </g>
      <g data-name="Group 85-3">
        <g data-name="Group 498-3">
          <path
            data-name="Rectangle 182-3"
            fill="#233762"
            d="M34.54 8.28L6.75 2.25v49.49l27.79 6.8V8.28z"
          />
          <path
            data-name="Path 2338-3"
            d="M6.26 1.52L35 7.75V59.3l-28.78-7zM34 8.79L7.24 3v48.24L34 57.79z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-3">
          <path
            data-name="Rectangle 183-3"
            fill="#233762"
            d="M31.54 12.94L9.49 8.09v3.56l22.05 4.9v-3.61z"
          />
          <path
            data-name="Path 2339-3"
            d="M9.24 7.71l22.55 5V17L9.24 12zm22 5.49L9.75 8.46v2.92l21.52 4.77z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-3">
          <path
            data-name="Rectangle 184-3"
            fill="#233762"
            d="M31.54 16.55l-22.05-4.9v3.57l22.05 4.94v-3.61z"
          />
          <path
            data-name="Path 2340-3"
            d="M9.24 11.27l22.55 5v4.27L9.24 15.48zm22 5.54L9.75 12v3l21.52 4.81z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-3">
          <path
            data-name="Rectangle 185-3"
            fill="#233762"
            d="M31.54 20.16L9.49 15.22v3.58l22.05 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-3"
            d="M9.24 14.84l22.55 5v4.28L9.24 19.05zm22 5.58L9.75 15.6v2.92l21.52 4.87z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-3">
          <path
            data-name="Rectangle 186-3"
            fill="#233762"
            d="M31.54 23.8L9.49 18.82v3.57l22.05 5.02V23.8z"
          />
          <path
            data-name="Path 2342-3"
            d="M9.24 18.43l22.55 5.1v4.27L9.24 22.65zm22 5.64L9.75 19.19v2.93L31.27 27z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-3">
          <path
            data-name="Rectangle 187-3"
            fill="#233762"
            d="M31.54 27.41L9.49 22.39v3.57l22.05 5.06v-3.61z"
          />
          <path
            data-name="Path 2343-3"
            d="M9.24 22l22.55 5.13v4.27L9.24 26.22zm22 5.67l-21.49-4.9v2.92l21.52 4.94z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-3">
          <path
            data-name="Rectangle 188-3"
            fill="#233762"
            d="M31.54 31.02L9.49 25.96v3.56l22.05 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-3"
            d="M9.24 25.57l22.55 5.18V35L9.24 29.79zm22 5.72l-21.52-5v2.92l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-3">
          <path
            data-name="Rectangle 189-3"
            fill="#233762"
            d="M31.54 34.63L9.49 29.52v3.57l22.05 5.15v-3.61z"
          />
          <path
            data-name="Path 2345-3"
            d="M9.24 29.14l22.55 5.23v4.26L9.24 33.35zm22 5.76l-21.52-5v2.93l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-3">
          <path
            data-name="Rectangle 190-3"
            fill="#233762"
            d="M31.54 38.24L9.49 33.09v3.57l22.05 5.2v-3.62z"
          />
          <path
            data-name="Path 2346-3"
            d="M9.24 32.71L31.79 38v4.27L9.24 36.92zm22 5.8l-21.52-5v2.92l21.52 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-3">
          <path
            data-name="Rectangle 191-3"
            fill="#233762"
            d="M31.54 41.86l-22.05-5.2v3.56l22.05 5.25v-3.61z"
          />
          <path
            data-name="Path 2347-3"
            d="M9.24 36.28l22.55 5.31v4.27L9.24 40.49zm22 5.84L9.75 37v3l21.52 5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-3">
          <path
            data-name="Rectangle 192-3"
            fill="#233762"
            d="M31.54 45.49L9.49 40.25v3.57l22.05 5.29v-3.62z"
          />
          <path
            data-name="Path 2348-3"
            d="M9.24 39.87l22.55 5.36v4.27L9.24 44.08zm22 5.89L9.75 40.63v2.92l21.52 5.17z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-3">
          <path
            data-name="Rectangle 193-3"
            fill="#233762"
            d="M31.54 49.11L9.49 43.82v3.57l22.05 5.33v-3.61z"
          />
          <path
            data-name="Path 2349-3"
            d="M9.24 43.43l22.55 5.41v4.27L9.24 47.65zm22 5.94L9.75 44.2v2.92l21.52 5.21z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-3"
          fill="#fff"
          d="M21.07 10.63l-1.44-.32v39.53l1.44.35V10.63z"
        />
      </g>
      <g data-name="Group 85-4">
        <g data-name="Group 498-4">
          <path
            data-name="Rectangle 182-4"
            fill="#233762"
            d="M65.61 8.28L37.82 2.25v49.49l27.79 6.8V8.28z"
          />
          <path
            data-name="Path 2338-4"
            d="M37.33 1.52l28.78 6.23V59.3l-28.78-7zM65.1 8.79L38.31 3v48.24l26.79 6.55z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-4">
          <path
            data-name="Rectangle 183-4"
            fill="#233762"
            d="M62.6 12.94L40.56 8.09v3.56l22.04 4.9v-3.61z"
          />
          <path
            data-name="Path 2339-4"
            d="M40.31 7.71l22.55 5V17l-22.55-5zm22 5.49L40.82 8.46v2.92l21.52 4.77z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-4">
          <path
            data-name="Rectangle 184-4"
            fill="#233762"
            d="M62.6 16.55l-22.04-4.9v3.57l22.04 4.94v-3.61z"
          />
          <path
            data-name="Path 2340-4"
            d="M40.31 11.27l22.55 5v4.27l-22.55-5.06zm22 5.54L40.82 12v3l21.52 4.81z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-4">
          <path
            data-name="Rectangle 185-4"
            fill="#233762"
            d="M62.6 20.16l-22.04-4.94v3.58l22.04 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-4"
            d="M40.31 14.84l22.55 5v4.28L40.31 19zm22 5.58L40.82 15.6v2.92l21.52 4.87z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-4">
          <path
            data-name="Rectangle 186-4"
            fill="#233762"
            d="M62.6 23.8l-22.04-4.98v3.57l22.04 5.02V23.8z"
          />
          <path
            data-name="Path 2342-4"
            d="M40.31 18.43l22.55 5.1v4.27l-22.55-5.15zm22 5.64l-21.49-4.88v2.93L62.34 27z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-4">
          <path
            data-name="Rectangle 187-4"
            fill="#233762"
            d="M62.6 27.41l-22.04-5.02v3.57l22.04 5.06v-3.61z"
          />
          <path
            data-name="Path 2343-4"
            d="M40.31 22l22.55 5.13v4.27l-22.55-5.18zm22 5.67l-21.49-4.9v2.92l21.52 4.94z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-4">
          <path
            data-name="Rectangle 188-4"
            fill="#233762"
            d="M62.6 31.02l-22.04-5.06v3.56l22.04 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-4"
            d="M40.31 25.57l22.55 5.18V35l-22.55-5.21zm22 5.72l-21.52-5v2.92l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-4">
          <path
            data-name="Rectangle 189-4"
            fill="#233762"
            d="M62.6 34.63l-22.04-5.11v3.57l22.04 5.15v-3.61z"
          />
          <path
            data-name="Path 2345-4"
            d="M40.31 29.14l22.55 5.23v4.26l-22.55-5.28zm22 5.76l-21.52-5v2.93l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-4">
          <path
            data-name="Rectangle 190-4"
            fill="#233762"
            d="M62.6 38.24l-22.04-5.15v3.57l22.04 5.2v-3.62z"
          />
          <path
            data-name="Path 2346-4"
            d="M40.31 32.71L62.86 38v4.27l-22.55-5.35zm22 5.8l-21.52-5v2.92l21.52 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-4">
          <path
            data-name="Rectangle 191-4"
            fill="#233762"
            d="M62.6 41.86l-22.04-5.2v3.56l22.04 5.25v-3.61z"
          />
          <path
            data-name="Path 2347-4"
            d="M40.31 36.28l22.55 5.31v4.27l-22.55-5.37zm22 5.84L40.82 37v3l21.52 5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-4">
          <path
            data-name="Rectangle 192-4"
            fill="#233762"
            d="M62.6 45.49l-22.04-5.24v3.57l22.04 5.29v-3.62z"
          />
          <path
            data-name="Path 2348-4"
            d="M40.31 39.87l22.55 5.36v4.27l-22.55-5.42zm22 5.89l-21.49-5.13v2.92l21.52 5.17z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-4">
          <path
            data-name="Rectangle 193-4"
            fill="#233762"
            d="M62.6 49.11l-22.04-5.29v3.57l22.04 5.33v-3.61z"
          />
          <path
            data-name="Path 2349-4"
            d="M40.31 43.43l22.55 5.41v4.27l-22.55-5.46zm22 5.94L40.82 44.2v2.92l21.52 5.21z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-4"
          fill="#fff"
          d="M52.14 10.63l-1.44-.32v39.53l1.44.35V10.63z"
        />
      </g>
      <path
        fill="#233762"
        d="M36.08 3.44h1.26v45.27h-1.26zM97.16 3.44h1.26v45.27h-1.26z"
      />
    </svg>
  );
};
